import React, { Suspense, useEffect, useImperativeHandle, useRef } from 'react';
import Button from '@/component/button';

const withLogs = function (Com) {
  class WithLog extends React.Component<any, any> {
    render() {
      const { testRef, ...resProps } = this.props;
      return <Com {...resProps} ref={testRef} />;
    }
  }

  return React.forwardRef((props, ref) => {
    return <WithLog {...props} testRef={ref} />;
  });
};

const Fnc = (props, ref) => {
  // console.log(props,ref)
  return <input type="text" ref={ref} />;
};

class FncText extends React.Component<any, any> {
  state = {
    value: 22,
  };

  updateValues = (v) => {
    this.setState({
      value: v,
    });
  };

  render() {
    const { testRef } = this.props;
    const { value } = this.state;
    return (
      <input
        type="text"
        ref={testRef}
        value={value}
        onChange={(e) => {
          this.setState({
            value: e.target.value,
          });
        }}
      />
    );
  }
}

const NewFnc = React.forwardRef(Fnc);
const NewFncText = React.forwardRef((props, ref) => {
  return <FncText {...props} testRef={ref}></FncText>;
});

const WithLogFnc = withLogs(FncText);

const SearchAdd = (props, ref) => {
  const [v, setV] = React.useState<any>(0);
  useImperativeHandle(ref, () => ({
    updateValues: (v) => {
      console.log(v);
      setV(v);
    },
  }));

  return <input value={v} onChange={(e) => setV(e.target.value)}></input>;
};

const NewSearchAdd = React.forwardRef(SearchAdd);
function Index() {
  const clsRef = useRef();
  const fncRef = useRef();

  useEffect(() => {
    // console.log(clsRef);
  }, [clsRef]);
  return (
    <div>
      {/* <Suspense> */}

      {/* </Suspense> */}
      {/* <NewFncText ref={clsRef} /> */}
      <NewSearchAdd ref={clsRef} />
      {/* <NewFnc ref={fncRef}></NewFnc> */}
      {/* <WithLogFnc ref={clsRef} /> */}
      <Button
        onClick={() => {
          console.log(clsRef);
          if (clsRef.current) {
            // @ts-ignore
            clsRef.current.updateValues(Math.random());
          }
        }}
      >
        按钮
      </Button>
    </div>
  );
}

export default class Demo extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }
  handleClick = () => {
    const num = undefined;
    num.toFixed(); // 报错：num is not a functio
  }
  render() {
    return <>demo
      <div onClick={this.handleClick}>JS错误</div>

    </>;
  }
}
